import { useLocation } from 'react-router-dom'

export default ({ keys }: { keys: string[] }) => {
    let values: string[] = []
    const searchParams = new URLSearchParams(useLocation().search)

    keys.forEach((key) => {
        values.push(searchParams.get(key) as string)
    })

    return { values }
}
